import React from 'react'
import DataGrid, { Column, StateStoring, GroupItem, Grouping, Summary, Paging, Pager } from 'devextreme-react/data-grid';

import saveAs from 'file-saver'
import { Workbook } from 'exceljs'
import withRouter from '../helpers/withRouter'

import { getGridInstance } from "../helpers/gridHandler";
import { exportDataGrid } from 'devextreme/excel_exporter'

class DataGridBase extends React.Component {
  allowedPageSizes = [10, 20, 50];
  exportFormats = ['xlsx'];
  exportGrid(e) {
    if (e.format === 'xlsx') {
        const workbook = new Workbook()
        const worksheet = workbook.addWorksheet("Main sheet")

        exportDataGrid({
            worksheet,
            component: e.component
        }).then(function() {
            workbook.xlsx.writeBuffer().then(function(buffer) {
                saveAs(new Blob([buffer], { type: "application/octet-stream" }), "DataGrid.xlsx")
            })
        })

        e.cancel = true
    }
  }

  render() { 

    return (
      <>
      { // DataGrid which needs grouping
        this.props.groupedNotices === true && (          
          <DataGrid
            keyExpr="gridContainer"
            onContentReady={getGridInstance}
            dataSource={this.props.dataSource}
            allowColumnReordering={true}
            allowHeaderFiltering={true}
            export={{ enabled: true, formats: this.exportFormats}}
            onExporting={this.exportGrid}                  
            headerFilter={{ visible: true, allowSearch: true}}
            groupPanel={{ visible: true }}
            loadPanel={{ enabled: true }}
            allowColumnResizing={true}
            columnAutoWidth={true}
            showBorders={true}
            showColumnLines={true}
            showRowLines={true}
            rowAlternationEnabled={true}  
          >    
          <Paging
            enabled={true}
            defaultPageIndex={0}
            defaultPageSize={10} 
          />    
          <Pager 
            visible={true}
            allowedPageSizes={this.allowedPageSizes}
            showInfo={true}
            showPageSizeSelector={true}
            showNavigationButtons={true}
          />     
          <Grouping autoExpandAll={false} />
          <StateStoring enabled={true} type="localStorage" storageKey="noticesTable" />
          <Column dataField="instance" dataType="string" caption="Instance" groupIndex={0} />
          <Column dataField="workflow" dataType="string" caption="Workflow"/>
          <Column dataField="count" dataType="int" caption="Count"/>
          <Summary>
              <GroupItem
                  column="count"
                  summaryType="sum"
                  displayFormat="{0} Notices" 
              />
          </Summary>     
        </DataGrid>
        )
      }

      { // used props here as unEditedDataGrid does not need grouping 
        this.props.unEditedDataGrid === true && ( 
        <DataGrid
          keyExpr="ID"
          dataSource={this.props.dataSource}
          allowColumnReordering={true}
          allowHeaderFiltering={true}
          export={{ enabled: true, formats: this.exportFormats}}
          onExporting={this.exportGrid}                  
          headerFilter={{ visible: true, allowSearch: true}}
          groupPanel={{ visible: false }}
          loadPanel={{ enabled: true }}
          allowColumnResizing={true}
          columnAutoWidth={true}
          showBorders={true}
          showColumnLines={true}
          showRowLines={true}
          rowAlternationEnabled={true}  
        >    
          <Paging
            enabled={true}
            defaultPageIndex={0}
            defaultPageSize={10} 
          />    
          <Pager 
            visible={true}
            allowedPageSizes={this.allowedPageSizes}
            showInfo={true}
            showPageSizeSelector={true}
            showNavigationButtons={true}
          />          
        </DataGrid>
        )
      }
      
      </>
    );
  }
}

export default withRouter(DataGridBase);